module.exports = {"more":{"title":"More","items":[{"title":"Cheatsheet","to":"/tutorial/tutorial.html"},{"title":"Blog","to":"/blog"}]}}